var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"printMe",staticClass:"view-print"},[_c('h1',{staticStyle:{"color":"#000"}},[_vm._v("Print me!")])]),_c('a',{attrs:{"href":_vm.output,"download":"Gift"}},[_vm._v("Save")]),_c('img',{attrs:{"src":_vm.output}})])
}
var staticRenderFns = []

export { render, staticRenderFns }